export default __webpack_public_path__ + "static/media/hispanicWomen20.81d2f968.svg";